<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../mixins/Forms";
    import Tickets from "../../../mixins/Tickets";
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
    } from 'tiptap-extensions';
    import axios from 'axios';
    import CreateContactModal from "./create/CreateContactModal";
    import AxumDetails from "./create/AxumDetails";

    /**
     * Projects-create component
     */
    export default {
        page: {
            title: "Create New Ticket",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {CreateContactModal, Layout, PageHeader, EditorMenuBar, EditorContent, AxumDetails},
        mixins: [Forms, Tickets],
        data() {
            return {
                title: "Create New Ticket",
                searchQuery: '',
                results: null,
                isSearching: false,
                searchQueryIsDirty: false,

                items: [
                    {
                        text: "Tickets",
                        href: "/tickets"
                    },
                    {
                        text: "Create Ticket",
                        active: true
                    }
                ],

                notRelatedToAxumBooking: false,
                form: {
                    axum_booking_id: '',
                    travel_consultant_name: '',
                    travel_consultant_email: '',
                    subject: '',
                    source: 'phone',
                    difficulty: 1,
                    priority: 0,
                    status: 0,
                    // agent_id: null
                },
                selectedContact: null,
                editor: null,
                agents: [],
                contacts: null,
                serverErrors: [],
                isSaving: false,
                isLoadingAgents: false,
                isLoadingTicketTemplates: false,
                ticketTemplates: [],

                selectedTicketTemplate: null,

                isAxumLoaded: false
            };
        },
        watch: {
            '$route': 'fetchAgents',
            searchQuery: function () {
                this.searchQueryIsDirty = true;
                this.search();
            },
            selectedTicketTemplate(newTemplateSelected) {
                let vm = this;
                if (newTemplateSelected !== null) {
                    swal({
                        title: "Are you sure you want to apply the template '" + newTemplateSelected.name + "'?",
                        text: "This will overwrite any data you've entered manually",
                        icon: "info",
                        buttons: {
                            cancel: true,
                            confirm: "Apply Template"
                        }
                    }).then((shouldApply) => {
                        if (shouldApply) {
                            vm.form = {
                                ...vm.form,
                                ...newTemplateSelected
                            };
                            vm.editor.setContent(newTemplateSelected.description)
                        } else {
                            vm.selectedTicketTemplate = null;
                        }
                    });
                }
            }
        },
        mounted() {
            this.setupEditor();
        },
        created() {
            this.fetchAgents();
            this.fetchTicketTemplates();
        },
        computed: {
            contactResults() {
                if (this.contacts) {
                    return _.map(this.contacts.data, contact => {
                        let c = contact;
                        c.full_name = contact.first_name + ' ' + contact.last_name;
                        return c;
                    });
                }
                return [];
            }
        },
        methods: {
            search: _.debounce(function (page = 1) {
                this.isSearching = true;

                var vm = this;
                vm.results = null;
                axios.post(API_BASE + '/axum-search', {
                    q: this.searchQuery
                })
                    .then(function (r) {
                        vm.results = r.data;
                        vm.isSearching = false;
                        vm.searchQueryIsDirty = false;
                    })
                    .catch(function (e) {
                        vm.setErrors(e);
                        console.log(e);
                    });
            }, 1000),

            setBookingId(id) {
                this.notRelatedToAxumBooking = false;
                this.form.axum_booking_id = id;
                this.form.travel_consultant_name = null;
                this.form.travel_consultant_email = null;
                this.isAxumLoaded = false;

                if (id) {
                    this.form.subject = id + ' - ';
                }
            },

            setAsNotRelatedToAxumBooking() {
                this.form.axum_booking_id = null;
                this.form.travel_consultant_name = null;
                this.form.travel_consultant_email = null;
                this.notRelatedToAxumBooking = true;
                this.isAxumLoaded = true;
            },

            handleAxumDataLoaded(axumData) {
                if (axumData && axumData.consultant && axumData.consultant.username) {
                    this.form.travel_consultant_name = axumData.consultant.username;
                }

                if (axumData && axumData.consultant && axumData.consultant.emailAlias) {
                    this.form.travel_consultant_email = axumData.consultant.emailAlias;
                }
            },

            fetchAgents() {
                let vm = this;
                vm.serverErrors = [];
                vm.isLoadingAgents = true;

                axios.get(API_BASE + '/users').then(r => {
                    vm.isLoadingAgents = false;
                    vm.agents = r.data;
                }).catch(e => {
                    console.log(e);
                    vm.isLoadingAgents = false;
                    vm.setErrors(e);
                });
            },

            fetchTicketTemplates() {
                let vm = this;
                vm.serverErrors = [];
                vm.isLoadingTicketTemplates = true;

                axios.get(API_BASE + '/ticket-templates').then(r => {
                    vm.isLoadingTicketTemplates = false;
                    vm.ticketTemplates = r.data;
                }).catch(e => {
                    console.log(e);
                    vm.isLoadingTicketTemplates = false;
                    vm.setErrors(e);
                });
            },

            attemptSave() {
                if (this.selectedContact == null) {
                    this.serverErrors = ['Please select or create a contact'];
                    return false;
                }

                this.save();
            },

            save() {
                let vm = this;
                vm.serverErrors = [];

                if (this.isLoadingAgents || this.isLoadingTicketTemplates || this.isSaving) {
                    return false;
                }

                let formParams = {
                    ...vm.form,
                    description: vm.editor.getHTML(),
                    primary_contact_id: vm.selectedContact.id
                };

                vm.isSaving = true;
                axios.post(API_BASE + '/tickets', formParams).then(r => {
                    vm.isSaving = false;
                    vm.$router.push('/tickets/' + r.data.id);
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            },

            setupEditor() {
                let vm = this;
                this.editor = new Editor({
                    extensions: [
                        new Blockquote(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({levels: [1, 2, 3]}),
                        new BulletList(),
                        new OrderedList(),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Link(),
                        new Strike(),
                        new Underline(),
                        new History(),
                    ]
                })
            },

            onSearchContacts(search, loading) {
                if (search.length) {
                    loading(true);
                    this.searchContacts(loading, search, this);
                }
            },

            searchContacts: _.debounce((loading, search, vm) => {
                axios.post(API_BASE + '/contacts/search', {
                    q: search
                }).then(r => {
                    loading(false);
                    vm.contacts = r.data;
                }).catch(e => {
                    console.log(e);
                    loading(false);
                    vm.contacts = [];
                });
            }),

            selectContact(contact) {
                let c = contact;
                c.full_name = contact.first_name + ' ' + contact.last_name;
                this.selectedContact = c;
            },

            getBookingPropertyValue(booking, columnName) {
                let column = _.find(this.results.columns, {'columnName': columnName});

                if (column) {
                    let cell = _.find(booking.cells, {columnId: column.columnId});
                    return cell ? cell.value : '';
                } else {
                    return '';
                }
            },

            setIsAxumLoaded(isLoaded) {
                this.isAxumLoaded = isLoaded;
            },

            setPrimaryContactFromAxum(contact) {
                this.selectedContact = contact;
            }
        }
    };
</script>

<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-lg-11">
                <PageHeader :title="title" :items="items"/>
                <errors :error-list="serverErrors"></errors>
                <loading-screen :is-loading="isSaving"></loading-screen>
            </div>
        </div>

        <div class="row justify-content-center" v-if="!form.axum_booking_id && notRelatedToAxumBooking == false">
            <div class="col-lg-11">
                <div class="card">
                    <div class="card-body">
                        <label for="searchQuery">Search for AXUM booking:</label>

                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <div class="input-group">
                            <input
                                id="searchQuery"
                                ref="searchQuery"
                                name="searchQuery"
                                type="text"
                                class="form-control"
                                v-model="searchQuery"
                                autofocus
                            />
                            <div class="input-group-append">
                              <button
                                  type="button"
                                  class="btn btn-itg"
                                  @click.prevent="search"
                              >
                                <i class="fa fa-search mr-1"></i>
                                Search
                              </button>
                            </div>
                          </div>

                        </div>
<!--                        <div class="flex-shrink-1">-->
<!--                       -->
<!--                        </div>-->
                      </div>

                    </div>
                </div>

                <a @click.prevent="setAsNotRelatedToAxumBooking" href="#" class="btn btn-itg-dark mt-1" v-if="!searchQuery && !form.axum_booking_id">
                    Not related to AXUM booking
                </a>

                <!-- Results -->
                <div class="card mt-3" v-if="searchQuery && !form.axum_booking_id && (notRelatedToAxumBooking == false)">
                    <div class="card-body">
                        <div v-if="searchQueryIsDirty||isSearching" class="text-center">
                            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
                        </div>

                        <div v-if="results && !(searchQueryIsDirty||isSearching)" class="table-responsive mb-0">
                            <table class="table mb-0 table-centered">
                                <thead class="thead-light">
                                <tr>
                                    <th>Booking ID</th>
                                    <th>Booking Title</th>
                                    <th>Client Name</th>
                                    <th>Departure Date</th>
                                    <th>Return Date</th>
                                    <th>Consultant</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="row in results.results.rows">
                                    <td>
                                        {{ getBookingPropertyValue(row, 'BookingId') }}
                                    </td>
                                    <td>
                                        {{ getBookingPropertyValue(row, 'BookingTitle') }}
                                    </td>
                                    <td>
                                        {{ getBookingPropertyValue(row, 'ClientName') }}
                                    </td>
                                    <td>
                                        {{ getBookingPropertyValue(row, 'DepartureDate').replace(' 00:00:00', '') }}
                                    </td>
                                    <td>
                                        {{ getBookingPropertyValue(row, 'ReturnDate').replace(' 00:00:00', '') }}
                                    </td>
                                    <td>
                                        {{ getBookingPropertyValue(row, 'ConsultantName') }}
                                    </td>
                                    <td class="text-right">
                                        <!-- Button trigger modal -->
                                        <button
                                                type="button"
                                                class="btn btn-itg btn-sm"
                                                @click.prevent="setBookingId(row['cells'][0].value)"
                                        >
                                            Select
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="ticketTemplates.length === 0">
                                    <th scope="row" colspan="3">
                                        <span class="text-danger">No results</span>
                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                <!-- / Results -->
            </div>
        </div>

        <div class="row justify-content-center" v-if="form.axum_booking_id || notRelatedToAxumBooking">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
                        <form @submit.prevent="attemptSave">
                            <div class="form-group row mb-4">
                                <label for="axumBookingId" class="col-form-label col-lg-2">Axum Booking ID</label>
                                <div class="col-lg-10">
                                    <!--                                    <input disabled-->
                                    <!--                                            id="axumBookingId"-->
                                    <!--                                            ref="axumBookingIdInput"-->
                                    <!--                                            name="axumBookingId"-->
                                    <!--                                            type="text"-->
                                    <!--                                            class="form-control disabled"-->
                                    <!--                                            v-model="form.axum_booking_id"-->
                                    <!--                                    />-->
                                    <div class="pt-2">
                                        <b>{{ form.axum_booking_id ? form.axum_booking_id : 'No AXUM Booking Linked' }}</b>
                                        <a href="#" class="btn btn-itg btn-sm ml-3" @click.prevent="setBookingId(null)">Change</a>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="contact" class="col-form-label col-lg-2">Primary Contact</label>
                                <div class="col-lg-10">
                                    <v-select @search="onSearchContacts" :disabled="!isAxumLoaded"
                                              :options="contactResults" label="full_name"
                                              v-model="selectedContact">
                                        <template v-slot:option="option">
                                            <div style="font-weight: 600;">{{ option.full_name }}</div>
                                            <div>
                                                {{ option.email ? option.email + ' | ' : null }}
                                                {{ option.phone_number }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="text-right pt-2">
                                        <a href="#" v-b-modal.create-contact-modal><i class="fa fa-plus"></i> New
                                            contact</a>
                                    </div>
                                    <create-contact-modal @select-contact="selectContact"></create-contact-modal>
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="subject" class="col-form-label col-lg-2">Subject</label>
                                <div class="col-lg-10">
                                    <input
                                            id="subject"
                                            name="subject"
                                            type="text"
                                            class="form-control"
                                            v-model="form.subject"
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="source" class="col-form-label col-lg-2">Source</label>

                                <div class="col-lg-10">
                                    <v-select v-model="form.source" :reduce="source => source.value"
                                              :options="ticketSourceDropdownOptions"></v-select>
                                </div>
                            </div>
                            <div class="form-group row mb-2">
                                <label for="description" class="col-form-label col-lg-2">Description</label>
                                <div class="col-lg-10">
                                    <div class="card shadow-none card-action">
                                        <div class="card-body p-3">
                                            <editor-content :editor="editor"/>
                                        </div>
                                        <div class="card-menubar">
                                            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                                                <div class="menubar">

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.bold() }"
                                                       @click="commands.bold"
                                                    >
                                                        <i class="fas fa-bold"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.italic() }"
                                                       @click="commands.italic"
                                                    >
                                                        <i class="fas fa-italic"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.strike() }"
                                                       @click="commands.strike"
                                                    >
                                                        <i class="fas fa-strikethrough"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.underline() }"
                                                       @click="commands.underline"
                                                    >
                                                        <i class="fas fa-underline"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.bullet_list() }"
                                                       @click="commands.bullet_list"
                                                    >
                                                        <i class="fas fa-list-ul"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.ordered_list() }"
                                                       @click="commands.ordered_list"
                                                    >
                                                        <i class="fas fa-list-ol"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       @click="commands.undo"
                                                    >
                                                        <i class="fas fa-undo"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       @click="commands.redo"
                                                    >
                                                        <i class="fas fa-redo"></i>
                                                    </a>
                                                </div>
                                            </editor-menu-bar>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="form-group row mb-4">
                                <label for="description" class="col-form-label col-lg-2">Difficulty</label>

                                <div class="col-lg-10">
                                    <v-select :options="ticketDifficultyDropdownOptions"
                                              :reduce="difficulty => difficulty.value"
                                              v-model="form.difficulty"></v-select>
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="priority" class="col-form-label col-lg-2">Priority</label>

                                <div class="col-lg-10">
                                    <v-select v-model="form.priority" :reduce="priority => priority.value"
                                              :options="ticketPriorityDropdownOptions"></v-select>
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="status" class="col-form-label col-lg-2">Status</label>

                                <div class="col-lg-10">
                                    <v-select v-model="form.status" :reduce="status => status.value"
                                              :options="ticketStatusDropdownOptions"></v-select>
                                </div>
                            </div>
                            <!--                            <div class="form-group row mb-4">-->
                            <!--                                <label for="agent" class="col-form-label col-lg-2">Agent</label>-->

                            <!--                                <div class="col-lg-10">-->
                            <!--                                    <v-select v-model="form.agent_id" :reduce="agent => agent.id" label="name"-->
                            <!--                                              :disabled="isLoading"-->
                            <!--                                              :options="agents"></v-select>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark"
                                        :disabled="(isLoadingAgents||isLoadingTicketTemplates||isSaving)"
                                        @click.prevent="attemptSave">Create
                                    Ticket
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="card card-body">
                    <h4 class="card-title mb-4">Ticket Templates</h4>
                    <v-select v-model="selectedTicketTemplate" placeholder="Pick a template"
                              :disabled="isLoadingTicketTemplates"
                              label="name"
                              :options="ticketTemplates"></v-select>
                </div>

                <axum-details v-if="form.axum_booking_id"
                             class="mt-3" @set-is-axum-loaded="setIsAxumLoaded"
                             @axum-data="handleAxumDataLoaded"
                              @set-primary-contact-from-axum="setPrimaryContactFromAxum"
                              :booking-id="form.axum_booking_id"></axum-details>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
